var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"value":_vm.localVal},on:{"input":_vm.onInput,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }